import { ApiResponse, ApisauceInstance } from 'apisauce';

export type PostUploadResponseSuccess = {
  code: number;
  message?: string;
};

export type PostUploadResponseError = {
  error: {
    code: number;
    message: string;
    errors?: string[];
  };
};

const postUpload = ({
  formData,
  dataType,
  provider,
  api,
}: {
  formData: FormData;
  dataType: string;
  provider: string;
  api: ApisauceInstance;
}): Promise<ApiResponse<PostUploadResponseSuccess, PostUploadResponseError>> =>
  // Clears the client's default 'content-type: application/json', which would
  // make axios serialise the FormData to JSON. The browser then sets
  // multipart/form-data with its boundary. The key must stay lowercase to
  // override the client's lowercase default ('Content-Type' would not).
  api.post(`/v1/uploads/${provider}/${dataType}`, formData, {
    headers: { 'content-type': undefined },
  });

export default postUpload;
